export default {
  save: 'Save changes',
}
